/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import axios from 'axios';
import config from '../../config';
import i18n from '../../i18n/index';
import pushNotification from '../../lib/push-notification';

const state = {
  quantity: 0,
  order: null,
};

function getLineItem(variant) {
  state.order.line_items.find((l) => l.variant_id === variant.id);
}

function setInLineItem(dispatch, variant, quantity) {
  const lineItem = getLineItem(variant);
  if (lineItem) {
    dispatch('updateLineItem', { lineItem, quantity });
  } else {
    dispatch('createLineItem', { variant, quantity });
  }
  pushNotification('success', i18n.tc('added', quantity), i18n.t('variant_added', { sku: variant.sku }));
}

function authenticationParams() {
  let token = null;
  if (config.solidus.userApiKey?.length > 0) {
    token = { Authorization: `Bearer ${config.solidus.userApiKey}` };
  } else if (config.solidus.guestToken.length > 0) {
    token = { 'X-Spree-Order-Token': config.solidus.guestToken };
  } else if (state.order && state.order.token.length > 0) {
    token = { 'X-Spree-Order-Token': state.order.token };
  }
  return token;
}

const mutations = {
  UPDATE_ORDER(state, payload) {
    state.order = payload;
  },
  UPDATE_QUANTITY(state, payload) {
    state.quantity = payload;
  },
};

const actions = {
  addVariant({ state, dispatch, commit }, { variant, quantity }) {
    commit('UPDATE_QUANTITY', quantity);
    if (state.order.id) {
      setInLineItem(dispatch, variant, quantity);
    } else {
      dispatch('createOrder').then((order) => {
        if (order) {
          setInLineItem(dispatch, variant, quantity);
        }
      });
    }
  },

  getCurrentOrder({ commit }) {
    const headers = {
      'content-type': 'application/json',
      ...authenticationParams(),
    };
    return axios({
      method: 'get',
      url: '/api/orders/current',
      headers,
    })
      .then((response) => {
        if (response.data) {
          commit('UPDATE_ORDER', response.data);

          const event = new CustomEvent('cart:refreshTotalQuantiy', {
            detail: response.data.total_quantity,
          });
          window.dispatchEvent(event);
        }
        return response.data;
      });
  },

  createOrder({ commit }) {
    const headers = {
      'content-type': 'application/json',
      ...authenticationParams(),
    };
    return axios({
      method: 'post',
      url: '/api/orders',
      headers,
    }).then((response) => {
      if (response.data) {
        commit('UPDATE_ORDER', response.data);
      }
      return response.data;
    });
  },

  createLineItem({ state, dispatch }, { variant, quantity }) {
    const headers = {
      'content-type': 'application/json',
      'X-CSRF-TOKEN': config.csrfToken,
      ...authenticationParams(),
    };
    return axios({
      method: 'post',
      url: `/api/checkouts/${state.order.number}/line_items`,
      headers,
      data: { variant_id: variant.id, quantity },
    }).then(() => {
      dispatch('getCurrentOrder');
    });
  },

  updateLineItem({ state, dispatch }, { lineItem, quantity }) {
    const newQuantity = lineItem.quantity + quantity;
    return axios({
      method: 'patch',
      url: `/api/checkouts/${state.order.number}/line_items/${lineItem.id}`,
      headers: {
        'content-type': 'application/json',
        'X-CSRF-TOKEN': config.csrfToken,
        'X-Spree-Order-Token': state.order.token,
      },
      data: { quantity: newQuantity },
    }).then(() => {
      dispatch('getCurrentOrder');
    });
  },
};

const getters = {
  order: (state) => state.order,
  quantity: (state) => state.quantity,
};

const cartModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default cartModule;
